import { type ClientAccountsResp } from 'shared/api/accounts'
import { type ConnectorResp } from 'shared/api/connectors'
import { type ConfigStatus } from 'shared/configStatuses'
import { type ConfigStatusResp } from 'shared/api/analytics'
import type { SupermetricsPlatform } from 'shared/thirdParty/supermetrics'

export interface MergedConfigData extends ConnectorResp {
  account?: ClientAccountsResp
  status?: ConfigStatusResp
  statusEnum?: ConfigStatus
}

export const ConnectorPlatformTypes = {
  ADOBE_ANALYTICS: 'adobe_analytics',
  AMAZON: 'amazon',
  BING: 'bing',
  CRITEO: 'criteo',
  DV360: 'dv360',
  FACEBOOK: 'facebook',
  GOOGLE_ADS: 'gads',
  GOOGLE_ANALYTICS: 'google_analytics',
  GOOGLE_ANALYTICS_4: 'ga4',
  GOOGLE_SEARCH_CONSOLE: 'google_search_console',
  GOOGLE_SHEETS: 'google_sheets',
  LINKEDIN: 'linkedin',
  LINKEDIN_ADS: 'linkedin_ads',
  PINTEREST_ADS: 'pinterest_ads',
  SHOPIFY: 'shopify',
  SNAPCHAT: 'snapchat',
  TIKTOK: 'tiktok',
  MERCHANT: 'merchant',
  PINTEREST: 'pinterest',
  CHATGPT_ADS: 'chatgpt_ads'
} as const

export interface ClientAccountsWithHasConnectors extends ClientAccountsResp {
  hasConnectors: boolean
}

export type ConnectorPlatformType =
  | (typeof ConnectorPlatformTypes)[keyof typeof ConnectorPlatformTypes]
  | SupermetricsPlatform
